import React from "react";

function CostPerRetainerIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#37367D" rx="5"></rect>
            <path
                fill="#fff"
                d="M26.965 35.008l4.657 3.998c.419.36.957.501 1.42.382.225-.068.666-.195.613-1.121l-4.716-3.94a.732.732 0 01-.098-1.046.74.74 0 011.054-.097l5.92 4.94a1.055 1.055 0 001.383-1.592l-5.808-5.247a.754.754 0 01-.052-1.061.745.745 0 011.054-.053l5.808 5.255c.164.15.299.322.418.508.225.075.606.083.823-.15.246-.26.755-.948.202-1.823-.397-.62-6.22-6.996-10.121-11.212l-3.028 2.556a3.106 3.106 0 01-4.223-.216 3.097 3.097 0 01-.045-4.261c.539-.583 1.181-1.263 1.824-1.929h-7.534v11.355l9.567 8.498c.733.658 1.675.994 2.564.92.538-.045.83-.21 1.01-.389l-3.663-3.14a.747.747 0 11.971-1.136z"
            ></path>
            <path
                fill="#fff"
                d="M23.34 24.049c.59.598 1.547.65 2.19.112l3.572-3.02a.754.754 0 011.032.068c1.39 1.502 7.31 7.915 9.747 10.711.254-.21.508-.523.747-.822.374-.464.755-.935 1.241-1.211v-10.95c-1.39.03-4.305-.06-6.69-1.144-2.78-1.271-6.899-.89-8.192.306-.105.097-.224.202-.336.314a.723.723 0 01-.456.441c-.942.927-2.034 2.085-2.878 2.99a1.609 1.609 0 00.022 2.205zM12.688 17a.686.686 0 00-.688.688v12.797c0 .38.306.687.688.687h1.644a.686.686 0 00.688-.688V17.689a.686.686 0 00-.688-.688h-1.644zM43.363 17.688v12.797c0 .38.307.687.688.687h1.644a.686.686 0 00.688-.688V17.689a.686.686 0 00-.688-.688h-1.644a.686.686 0 00-.688.688z"
            ></path>
        </svg>
    );
}

export default CostPerRetainerIcon;
